const MODAL_OPTIONS = {
  addTag: 'addTag',
  editTag: 'editTag',
  deleteTag: 'deleteTag',
};

export default MODAL_OPTIONS;
